import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Users, CalendarDays } from "lucide-react";

export default function Committees() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/committees").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="committees-page">
      <div className="max-w-3xl">
        <div className="overline">Volunteer work</div>
        <h1 className="mt-5 font-heading text-4xl sm:text-5xl leading-tight">AzSAM Committees &amp; Task Forces</h1>
        <p className="mt-5 text-lg text-[color:var(--azsam-ink-soft)] leading-relaxed">
          AzSAM is actively seeking members who are passionate about advancing the field of
          addiction medicine to serve in leadership roles within the organization. We are currently
          recruiting committee leaders to help guide our Legislative Advocacy, Education, and Member
          Engagement initiatives, providing a meaningful opportunity to shape AzSAM's priorities,
          influence policy, support professional development, and strengthen our addiction medicine
          community across Arizona.
        </p>
      </div>

      <div className="mt-14 grid md:grid-cols-3 gap-6" data-testid="committees-grid">
        {items.map((c) => (
          <div key={c.id} className="azsam-card p-8 flex flex-col" data-testid={`committee-${c.id}`}>
            {c.focus && <div className="overline text-[color:var(--azsam-sage-hover)]">{c.focus}</div>}
            <h3 className={`${c.focus ? "mt-3" : ""} font-heading text-2xl leading-snug`}>{c.name}</h3>
            <p className="mt-4 text-sm text-[color:var(--azsam-ink-soft)] leading-relaxed">{c.description}</p>
            <div className="mt-auto pt-6 border-t border-[color:var(--azsam-stone)] text-sm space-y-2 text-[color:var(--azsam-ink-soft)]">
              <div className="flex items-center gap-2"><Users size={14} /> <span className="font-medium text-[color:var(--azsam-ink)]">Chair:</span> {c.chair}</div>
              {c.meeting_cadence && (
                <div className="flex items-center gap-2"><CalendarDays size={14} /> {c.meeting_cadence}</div>
              )}
            </div>
          </div>
        ))}
      </div>

      {items.length === 0 && (
        <div className="text-center py-16 text-[color:var(--azsam-ink-soft)]" data-testid="committees-empty">
          Committee list is being updated.
        </div>
      )}
    </div>
  );
}
